import React, { useEffect,useState } from "react";
import { FaTrash, FaShareAlt, FaCheck } from "react-icons/fa";
import ShareModal from "./ShareBookmarkModal"; // ✅ Componente de modal de compartir
import Spiner from '../../components/General/Spiner';



const BookmarkSidebar = ({ reportRef, onResetDashboard }) => {
  const [spiner, setSpiner] = useState(false);
  
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [activeTab, setActiveTab] = useState("my"); // "my" o "shared"
  const [myBookmarks, setMyBookmarks] = useState([]);
  const [sharedBookmarks, setSharedBookmarks] = useState([]);
  const [newBookmarkName, setNewBookmarkName] = useState("");

  const codigoUsuario = localStorage.getItem("codigoUsuario");
  const codigoTablero = localStorage.getItem("idTableoBI");

  // --- Estados para la modal de compartir ---
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const [bookmarkToShare, setBookmarkToShare] = useState(null);

  const [activeBookmarkId, setActiveBookmarkId] = useState(null);



  // --- Cargar bookmarks ---
  const fetchBookmarks = async (tab) => {
    try {
      const url =
        `https://analitica.phantomx.com.ec/analitica/v1/portal_bi/dashboard/tableros/marcador/consultar_marcador?idMarcador=0&codigoUsuario=${codigoUsuario}&page=0&perPage=0&idTablero=${codigoTablero}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Application: "UEhBTlRPTVhfREJJ",
          IdOrganizacion: "365509c8-9596-4506-a5b3-487782d5876e",
        },
      });

      if (!response.ok) throw new Error("Error al cargar bookmarks");

      const data = await response.json();
      const bookmarksArray =
        data?.data?.data && Array.isArray(data.data.data)
          ? data.data.data
          : [];

      if (tab === "my") setMyBookmarks(bookmarksArray);
      else setSharedBookmarks(bookmarksArray);
    } catch (err) {
      console.error(err);
      setModalMessage("Error cargando bookmarks. Ver consola para detalles");
      setModalVisible(true);
    }
  };

  // --- Guardar bookmark ---
const saveBookmark = async () => {
  setSpiner(true);

  if (!reportRef.current || !newBookmarkName.trim()) return;

  try {
    const pages = await reportRef.current.getPages();

    // 🔹 Filtra solo las páginas visibles (visibility === 0)
    const visiblePages = pages.filter((page) => page.visibility === 0);

    // 🟢 Mostrar en consola las páginas visibles
    //console.log("📄 Páginas visibles:",visiblePages.map((p) => `${p.displayName} (${p.name})`));

    const allPagesState = [];

    // 🔹 Recorre solo las páginas visibles
    for (const page of visiblePages) {
      await page.setActive();
      const state = await reportRef.current.bookmarksManager.capture();

      allPagesState.push({
        name: page.name,
        displayName: page.displayName,
        state: state.state,
      });
    }

    // 🔹 Volvemos a la primera pestaña visible
    if (visiblePages.length > 0) {
      await visiblePages[0].setActive();
    }

    const response = await fetch(
      "https://analitica.phantomx.com.ec/analitica/v1/portal_bi/dashboard/tableros/marcador/crear_marcador",
      {
        method: "POST",
        headers: {
          Application: "UEhBTlRPTVhfREJJ",
          IdOrganizacion: "365509c8-9596-4506-a5b3-487782d5876e",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idMarcadorTablero: 0,
          nombre: newBookmarkName,
          codigoUsuario,
          descripcion: newBookmarkName,
          idTablero: codigoTablero,
          filtroJson: allPagesState,
          esPublico: "S",
          esActivo: "S",
          usuarioCreacion: codigoUsuario,
        }),
      }
    );

    if (response.ok) {
      setModalMessage("Marcador guardado correctamente!");
      setNewBookmarkName("");
      fetchBookmarks("my");
      setSpiner(false);
    } else {
      console.error("Error guardando bookmark:", response.statusText);
      setModalMessage("Error guardando bookmark en el servidor.");
    }

    setModalVisible(true);
  } catch (err) {
    console.error("Error al guardar bookmark:", err);
    setModalMessage("Error al guardar bookmark. Ver consola para detalles.");
    setModalVisible(true);
  }
};







  // --- Eliminar bookmark ---
const deleteBookmark = async (idMarcador) => {
  try {
    // --- Eliminar marcador en la API ---
    const response = await fetch(
      "https://analitica.phantomx.com.ec/analitica/v1/portal_bi/dashboard/tableros/marcador/crear_marcador",
      {
        method: "POST",
        headers: {
          Application: "UEhBTlRPTVhfREJJ",
          IdOrganizacion: "365509c8-9596-4506-a5b3-487782d5876e",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idMarcadorTablero: idMarcador,
          nombre: newBookmarkName,
          codigoUsuario,
          descripcion: newBookmarkName,
          idTablero: codigoTablero,
          esPublico: "S",
          esActivo: "N",
          usuarioCreacion: codigoUsuario,
        }),
      }
    );

    if (!response.ok) throw new Error("Error eliminando bookmark");

    // 🔹 Solo reiniciamos dashboard si borramos el bookmark activo
    if (activeBookmarkId === idMarcador) {
      await reportRef.current.refresh();
      if (typeof onResetDashboard === "function") {
        onResetDashboard();
      }
      setActiveBookmarkId(null); // 🔹 desmarcamos el bookmark activo
    }

    setModalMessage("Marcador eliminado correctamente!");
    setModalVisible(true);

    // Recargar bookmarks
    fetchBookmarks("my");
  } catch (err) {
    console.error(err);
    setModalMessage("Error al eliminar el marcador");
    setModalVisible(true);
  }
};



const loadBookmark = async (marcador) => {
  setSpiner(true);

  if (!reportRef.current) {
    setModalMessage("Reporte no cargado aún.");
    setModalVisible(true);
    return;
  }

  try {
    // Parseamos filtroJson si viene como string
    const filtros =
      typeof marcador.filtroJson === "string"
        ? JSON.parse(marcador.filtroJson)
        : marcador.filtroJson;

    // Obtenemos solo las páginas visibles (visibility === 0)
    const pages = (await reportRef.current.getPages()).filter(p => p.visibility === 0);
    //console.log("📄 Páginas visibles a aplicar:", pages.map(p => p.displayName));

    for (const pageState of filtros) {
      // Buscamos solo entre las páginas visibles
      const page = pages.find((p) => p.name === pageState.name);
      if (page) {
        await page.setActive();
        await reportRef.current.bookmarksManager.applyState(pageState.state);
        console.log(`✅ Estado aplicado a página: ${page.displayName}`);
      }
    }

    // Volvemos a la primera página visible
    if (pages.length) await pages[0].setActive();

    setActiveBookmarkId(marcador.idMarcadorTablero);
    setSpiner(false);
    setModalMessage("Marcador cargado correctamente");
    setModalVisible(true);
  } catch (err) {
    console.error("Error al cargar marcador:", err);
    setModalMessage("Error al cargar bookmark. Ver consola para detalles.");
    setModalVisible(true);
  }
};






  // --- Compartir bookmark ---
  const shareBookmark = (bookmark) => {
    setBookmarkToShare(bookmark);
    setShareModalVisible(true);
  };

  // --- useEffect para cargar bookmarks ---
  useEffect(() => {
    fetchBookmarks(activeTab);
  }, [activeTab]);

  const bookmarksToShow =
    activeTab === "my" ? myBookmarks : sharedBookmarks;

  return (
  <div
    style={{
      width: "260px",
      backgroundColor: "#f5f5f5",
      padding: "15px",
      borderLeft: "1px solid #ccc",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  >
     <Spiner opt={spiner} />
    <h4>📌</h4>

    {/* Tabs */}
    <div style={{ display: "flex", gap: "10px" }}>
      <button
        onClick={() => setActiveTab("my")}
        style={{
          flex: 1,
          padding: "6px 12px",
          borderRadius: "20px",
          border: "none",
          fontSize: "14px",
          cursor: "pointer",
          backgroundColor: activeTab === "my" ? "#007bff" : "#e0e0e0",
          color: activeTab === "my" ? "#fff" : "#333",
          transition: "0.2s",
        }}
      >
        Mis marcadores
      </button>
    </div>

    {/* Input + botón solo en Mis marcadores */}
    {activeTab === "my" && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          border: "1px solid #ccc",
          borderRadius: 8,
          padding: 8,
          boxSizing: "border-box",
          background: "#fff",
        }}
      >
        <input
          type="text"
          value={newBookmarkName}
          onChange={(e) => setNewBookmarkName(e.target.value)}
          placeholder="Nombre del marcador"
          style={{
            padding: "10px 12px",
            border: "1px solid #d0d0d0",
            borderRadius: 6,
            outline: "none",
            fontSize: "14px",
            boxSizing: "border-box",
            width: "100%",
          }}
        />
        <button
          onClick={saveBookmark}
          style={{
            marginTop: 4,
            width: "100%",
            padding: "8px 12px",
            borderRadius: 6,
            border: "none",
            backgroundColor: "#007bff",
            color: "#fff",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Guardar
        </button>
      </div>
    )}

    {/* Listado de marcadores */}
    <div>
      {bookmarksToShow.length > 0 ? (
        bookmarksToShow.map((bookmark, idx) => (
          <div
            key={bookmark.idMarcadorTablero || idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "6px",
              borderBottom: "1px solid #ccc",
              borderRadius: 4,
              backgroundColor:
                activeBookmarkId === bookmark.idMarcadorTablero
                  ? "#aac9e1ff" // 🔹 sombreado si está activo
                  : "transparent",
              transition: "background-color 0.2s",
            }}
          >
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {bookmark.nombre || `Marcador ${idx + 1}`}
            </span>
            <div style={{ display: "flex", gap: "8px" }}>
              <FaCheck
                style={{ cursor: "pointer", color: "green" }}
                title="Aplicar"
                onClick={() => loadBookmark(bookmark)}
              />
            {/* <FaShareAlt style={{ cursor: "pointer", color: "blue" }} title="Compartir" onClick={() => shareBookmark(bookmark)} />*/}
              <FaTrash
                style={{ cursor: "pointer", color: "red" }}
                title="Eliminar"
                onClick={() => deleteBookmark(bookmark.idMarcadorTablero)}
              />
            </div>
          </div>
        ))
      ) : (
        <p style={{ fontSize: "14px", color: "#666" }}>
          No hay marcadores disponibles
        </p>
      )}
    </div>

    {/* Modal de mensajes */}
    {modalVisible && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            textAlign: "center",
            minWidth: "300px",
          }}
        >
          <p>{modalMessage}</p>
          <button onClick={() => setModalVisible(false)}>Cerrar</button>
        </div>
      </div>
    )}

    {/* Modal de compartir */}
    <ShareModal
      visible={shareModalVisible}
      onClose={() => setShareModalVisible(false)}
      onSend={(bookmark, email, message) => {
        console.log("Bookmark a compartir:", bookmark);
        console.log("Email:", email);
        console.log("Mensaje:", message);
      }}
      bookmark={bookmarkToShare}
    />
  </div>
);

};

export default BookmarkSidebar;
